export default __webpack_public_path__ + "static/media/11.002d9232.webp";